import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { Button } from '@material-ui/core';
import React, { useContext } from 'react';
import { FaTags } from 'react-icons/fa';
import { VendaContext } from '../../VendaContext';
import { VendaModais } from '../modal/VendaModais';
import { vendaSearchStyles } from './styles';

const VendaSearchHeader = () => {
  const [, setSearch] = useContext(VendaContext).search;
  const [, setModal] = useContext(VendaContext).modal;

  const styles = vendaSearchStyles();

  const handleOpenBuscaAvancada = () => {
    setModal(VendaModais.buscaAvancada);
  };

  return (
    <>
      <PageHeader title="Vendas" icon={<FaTags />}>
        <div className={styles.searchHeaderVendas}>
          <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
            <SearchBar onChange={setSearch} placeholder="Pesquise pelo cliente ou identificador da venda" />
          </div>
          <div className="stepBuscaAvancada">
            <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
              Busca avançada
            </Button>
          </div>
        </div>
      </PageHeader>
    </>
  );
};

export default VendaSearchHeader;
